export default __webpack_public_path__ + "static/media/graph.98f20a7a.png";